import { Vue, Component } from 'vue-property-decorator'
import { Region } from '~/types/api/Region'
import LocationSvg from '~/assets/svg/popup-location.svg?inline'
import s from '~/utils/s'
import City from '~/types/api/pharmacy/City'

@Component
export default class RegionPopup extends Vue {
  targetRegionCode?: string = ''

  get selectedRegion (): Region | undefined {
    return s(this.$store).regions.region
  }

  created () {
    this.targetRegionCode = s(this.$store).regions.region?.code
  }

  mounted() {
    document.addEventListener('keydown', this.handleKeydown)
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown)
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      s(this.$store).general.closePopup()
    }
  }

  async selectRegion (region: Region, city: string) {
    window.scrollTo(0, 0);
    s(this.$store).regions.setChoiceCity(true)
    this.targetRegionCode = region.code
    this.$store.commit('regions/setSelectedCityName', city)
    await s(this.$store).regions.redirectRegionByCode(this.targetRegionCode ?? '')
    s(this.$store).general.closePopup()
  }

  render () {
    const allCities: { city: City; region: Region }[] = []

    s(this.$store).regions.regions.forEach((region: Region) => {
      if (region.cities && region.cities.length > 0) {
        region.cities.forEach((city: City) => {
          allCities.push({ city, region })
        })
      }
    })

    allCities.sort((a, b) => a.city.name.localeCompare(b.city.name))

    return (
      <div class="popup-regions">
        <div class="popup-regions__header">
          Выберите город
        </div>
        <div class="popup-regions__list">
          {allCities.map(({ city, region }) => (
            <div
              key={region.code}
              onClick={() => this.selectRegion(region, city.name)}
              class="popup-regions__item"
            >
              <div class="popup-regions__item-logo">
                <LocationSvg />
              </div>
              <div class="popup-regions__item-text">
                {city.name}
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }
}
